$('input#invalidate').on('change', ({ target }) => {
  const checked = $(target).is(':checked');
  $('select[name=version]').each((_, element) => {
    const url = $(element).data('url');
    const newUrl = checked ? url.replace('\?invalidate=false', '') : `${url}?invalidate=false`;
    $(element).data('url', newUrl);
    $(element).attr('data-url', newUrl);
  });
})
